require('./common-modal.scss');
let templateUrl = require('./common-modal.html');
/**
 * dialog = {
 *      title: 弹框标题；默认'温馨提示'
 *      okCb: 确认回调
 *      cancelCb: 取消回调
 *      closeCb: 关闭回调
 *      okBtn: 确认按钮文字；默认'确定'
 *      cancelBtn: 取消按钮文字；默认'取消'
 *      autoClose: 按确认或取消按钮后是否自动关闭弹框 默认 true
 *      hide: 隐藏的弹窗部分，用','隔开 e.g.   'header,footer,body,close'
 *      hideBtn: 对象，控制确认和取消按钮的显示
 *      mask: boolean, 是否显示遮罩层，默认 true
 * }
 */

angular.module('RCP').directive('commonModal', function () {
    return {
        template: templateUrl,
        restrict: 'E',
        transclude: true,
        scope: {
            config: '='
        },
        controller: function ($scope, $element, $timeout) {
            var modal = $($element[0]).find('.cm-modal');
            var modalMain = modal.find('.modal-main');

            /**
             * 点击确定事件
             */
            $scope.ok = function () {
                if ($scope.dialog.autoClose) {
                    closeModal();
                }
                $scope.config.okCb && $scope.config.okCb();
            };

            /**
             * 点击关闭事件
             */
            $scope.cancel = function () {
                if ($scope.dialog.autoClose) {
                    closeModal();
                }
                $scope.config.cancelCb && $scope.config.cancelCb();
            };

            /**
             * 关闭弹窗
             */
            $scope.close = function () {
                closeModal();
                $scope.config.closeCb && $scope.config.closeCb();
            };

            /**
             * 初始化
             */
            $scope.init = function () {
                $scope.dialog = $scope.config || {};
                $scope.dialog.autoClose = angular.isUndefined($scope.dialog.autoClose) ? true : $scope.dialog.autoClose;

                // 外部控制弹窗显示隐藏
                $scope.config.open = function () {
                    openModal();
                };

                // 关闭弹窗
                $scope.config.close = $scope.close;

                // 重置弹框位置
                $scope.config.resize = function (argNeedAnimate) {
                    modal.css({'visibility': 'visible'});
                    if (argNeedAnimate) {
                        modalMain.animate({'margin-left': -modalMain.width() / 2, 'margin-top': -modalMain.height() / 2});
                    } else {
                        modalMain.css({'margin-left': -modalMain.width() / 2, 'margin-top': -modalMain.height() / 2});
                    }
                };

                // 更新显示模块
                $scope.config.refShow = function () {
                    hideHandler();
                };

                // 处理默认配置
                $scope.dialog.mask = (angular.isUndefined($scope.config.mask) ? true : $scope.config.mask);
                $scope.dialog.autoClose = (angular.isUndefined($scope.config.autoClose) ? true : $scope.config.autoClose);

                // 处理隐藏的部分
                function hideHandler() {
                    if ($scope.dialog.hide) {
                        var _hideList = $scope.dialog.hide.split(',');
                        $scope.hideList = {};
                        angular.forEach(_hideList, function (value, key) {
                            $scope.hideList[value] = true;
                        });
                    }
                }

                hideHandler();
            };

            // 开启弹框
            function openModal() {
              $scope.config.show = true;
              modal.css({'visibility': 'hidden'});
              $timeout(function () {
                modal.css({'visibility': 'visible'});
                modalMain.css({'margin-left': -modalMain.width() / 2, 'margin-top': -modalMain.height() / 2});
                rcpAid.toggleHtmlOverflowHidden(true);
              });
            }

            // 关闭弹框
            function closeModal() {
              $scope.config.show = false;
              rcpAid.toggleHtmlOverflowHidden(false);
            }

            // ---------------------------------------------------
            $scope.init();
            // ---------------------------------------------------
        }
    }
});


// WEBPACK FOOTER //
// ./src/recruit/src/directive/common-modal/common-modal.js